import { render, staticRenderFns } from "./Regist.vue?vue&type=template&id=d363379a"
import script from "./Regist.vue?vue&type=script&lang=js"
export * from "./Regist.vue?vue&type=script&lang=js"
import style0 from "./Regist.vue?vue&type=style&index=0&id=d363379a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports